import { YandexEventName } from '@shared/lib/yandexMetrica/model/types';

export const getEventNameByFilter = (name: string): YandexEventName<'tasks'> | null => {
    switch (name) {
        case 'search':
            return 'filterSearch';
        case 'colors':
            return 'filterColor';
        case 'tags':
            return 'filterTags';
        case 'projects':
        case 'estimate':
            return 'filterObjectsOrEstimates';
        case 'executors':
            return 'filterExecutor';
        case 'type':
            return 'filterTypes';
        default:
            return null;
    }
};
